import { useSyncExternalStore } from 'react';

/**
 * Open/closed state of the one command palette, shared by the header trigger, the global ⌘K
 * listener and the palette itself — without a provider, because the trigger lives in the header and
 * the palette is mounted once beside the layout.
 */
let open = false;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());

export const paletteStore = {
	open: () => {
		if (open) return;
		open = true;
		emit();
	},
	close: () => {
		if (!open) return;
		open = false;
		emit();
	},
	toggle: () => {
		open = !open;
		emit();
	},
	get: () => open,
	subscribe: (listener: () => void) => {
		listeners.add(listener);
		return () => listeners.delete(listener);
	},
};

export const usePaletteOpen = () => useSyncExternalStore(paletteStore.subscribe, paletteStore.get, () => false);
